import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'next/router';
import { inject, observer } from 'mobx-react';
import withCustomComponent from 'ui/components/withCustomComponent';

import EventCard from 'ui/bw-ui/events/EventCard';

export const EventsPageList = withCustomComponent('EventsPageList')(
  inject(
    'appStore',
    'eventsStore',
  )(
    withRouter(
      observer(({ router, componentName, events }) => {
        const { t } = useTranslation();

        return (
          <ul
            data-component-name={componentName}
            className="list-grid list-grid--33 list-grid--lg-50 list-grid--md-50 list-grid--sm-100"
          >
            {events.map((event, i) => (
              <li key={i}>
                <EventCard event={event} />
              </li>
            ))}
          </ul>
        );
      }),
    ),
  ),
);
